import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  states: null,
  loadingStates: false,
  errorLoadingStates: null,
  statesList: [
    {
      chartType: '',
      riskOverTimeStateAbbreviation: '',
      currentRiskOverTimeCounties: [],
      potStateAbbreviation: '',
      currentPOTCounties: [],
      entireUnitedStateLabel: 'Entire US',
      entireUnitedStateAbbrevationLabel: 'EUS'
    }
  ]
}

const longitudinalStatesSlice = createSlice({
  name: 'longitudinalStates',
  initialState,
  reducers: {
    setStates: (state, action) => {
      state.states = action.payload
    },
    setLoadingStates: (state, action) => {
      state.loadingStates = action.payload
    },
    setErrorLoadingStates: (state, action) => {
      state.errorLoadingStates = action.payload
    },
    setStatesList: (state, action) => {
      state.statesList = action.payload
    },
    updateDefaultState: (state, action) => {
      const {chartName, value} = action.payload
      if (chartName === 'RiskOverTimeChart') {
        state.statesList[0].riskOverTimeStateAbbreviation = value
      }
      if (chartName === 'PopulationOverTimeChart') {
        state.statesList[0].potStateAbbreviation = value
      }
    },
    updateDefaultChartType: (state, action) => {
      const chartName = action.payload
      if (chartName === 'RiskOverTimeChart') {
        state.statesList[0].chartType = chartName
      }
      if (chartName === 'PopulationOverTimeChart') {
        state.statesList[0].chartType = chartName
      }
    },
    updateDefaultCounties: (state, action) => {
      const {chartName, counties} = action.payload
      if (chartName === 'RiskOverTimeChart') {
        state.statesList[0].currentRiskOverTimeCounties = counties
      }
      if (chartName === 'PopulationOverTimeChart') {
        state.statesList[0].currentPOTCounties = counties
      }
    },
    clearLongitudinalStates: (state) => {
      state.states = null
      state.loadingStates = false
      state.errorLoadingStates = null
      state.statesList = [
        {
          chartType: '',
          riskOverTimeStateAbbreviation: '',
          currentRiskOverTimeCounties: [],
          potStateAbbreviation: '',
          currentPOTCounties: [],
          entireUnitedStateLabel: 'Entire US',
          entireUnitedStateAbbrevationLabel: 'EUS'
        }
      ]
    }
  }
})

export const {
  setStates,
  setLoadingStates,
  setErrorLoadingStates,
  setStatesList,
  updateDefaultState,
  updateDefaultChartType,
  updateDefaultCounties,
  clearLongitudinalStates
} = longitudinalStatesSlice.actions

export const selectStates = (state) => state.longitudinalStates.states
export const selectLoadingStates = (state) => state.longitudinalStates.loadingStates
export const selectErrorLoadingStates = (state) => state.longitudinalStates.errorLoadingStates
export const selectStatesList = (state) => state.longitudinalStates.statesList

export default longitudinalStatesSlice.reducer
